import Vue from "vue";
import Vuex from "vuex";
import { Message } from "view-design";
import loginService from "@/interface/pages/Login/login";

Vue.use(Vuex);
// $store.getters.hasPermission($store.state.LIMIT_CONSTANTS.ROLE_LIMIT)
// 定义防抖函数
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default new Vuex.Store({
  state: {
    style: localStorage.getItem("style") || "atom",
    LIMIT_CONSTANTS: {
      CONTACTS_LIMIT: "ContactsLimit",
      FREE_EMAIL_QUOTA: "FreeEmailQuota",
      FREE_SMS_QUOTA: "FreeSMSQuota",
      AB_TEST_ENABLED: "ABTestEnabled",
      AUDIENCE_LIMIT: "AudienceLimit",
      USE_CASE_LIMIT: "UseCaseLimit",
      ACTION_LIMIT: "ActionLimit",
      ROLE_LIMIT: "RoleLimit",
      USER_LIMIT: "UserLimit",
      CONTENT_LIMIT: "ContentLimit",
    },
    buttonPermission: [],
    canvas: {},

    //记录选择的状态
    mSelectMode: undefined, //选择模式 （单选/多选）
    mSelectOneType: undefined, // 选择元素的类型（type）
    mSelectId: "", // 选择id
    mSelectIds: [], // 多选的时候选择id组
    mSelectObject: [], //选中的对象
    //多画板
    templates: [], // 全部画板数据
    templateIndex: 0, // 当前画板指针
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design: {
      process: {
        id: "root",
        parentId: null,
        type: "ROOT",
        name: "根节点",
        desc: "开始",
        thread: "",
        props: {
          assignedUser: [],
          formPerms: [],
        },
        children: {},
      },
    },
    isMenuVisible: true,
  },
  getters: {
    hasPermission: (state) => (feature_name, channel) => {
      let hasPermission = false;
      let permission = state.buttonPermission.find(
        (i) => i.feature_name === feature_name
      );

      // 提取公共逻辑
      const baseCheck = permission && permission.feature_available > 0;

      if (channel && (channel === "email" || channel === "sms")) {
        hasPermission = (permission && permission.allow_overage) || baseCheck;
      } else {
        hasPermission = baseCheck;
      }
      return !hasPermission;
      // return false
    },
  },
  mutations: {
    SET_BUTTON_PERMISSION(state, permissionMap) {
      state.buttonPermission = permissionMap;
    },
    exchangeStyle: (state, value) => {
      const style = value || "atom";
      state.style = style;
      localStorage.setItem("style", style);
    },
    changeCanvas(state, canvas) {
      // 变更状态
      state.canvas = canvas;
    },
    //增加操作步骤
    addList(state, payload) {
      const item = state.canvas.c.toJSON([
        "id",
        "gradientAngle",
        "selectable",
        "hasControls",
      ]);
      const handlelist = state.templates[state.templateIndex]
        ? state.templates[state.templateIndex].handlelist
        : [];
      if (handlelist) {
        handlelist.push(item);
      }
      state.canvas.c.requestRenderAll();
    },
    //回退历史操作
    delList(state) {
      const handlelist = state.templates[state.templateIndex].handlelist;
      const handlelistRedo = state.templates[state.templateIndex]
        ? state.templates[state.templateIndex].handlelistRedo
        : [];
      if (handlelist && handlelist.length > 1) {
        handlelistRedo.push(handlelist.pop());
      }
    },
    //撤销回退历史操作
    redoList(state) {
      const handlelist = state.templates[state.templateIndex].handlelist;
      const handlelistRedo = state.templates[state.templateIndex]
        ? state.templates[state.templateIndex].handlelistRedo
        : [];
      if (handlelistRedo && handlelistRedo.length > 0) {
        handlelist.push(handlelistRedo.pop());
      }
    },
    //清空操作历史
    clearHandlelist(state) {
      state.templates[state.templateIndex].handlelist = [];
      state.templates[state.templateIndex].handlelistRedo = [];
    },

    //初始化画板数据
    initTemplateHandlelist(state, template) {
      const templatelist = Array.isArray(template) ? template : [template];
      if (!templatelist.length) return;
      templatelist.forEach((item) => {
        state.templates.push({
          handlelist: [item],
          handlelistRedo: [],
        });
      });
    },

    //添加空白画板
    addEmptyTemplate(state, emptyTemplate) {
      if (!emptyTemplate) throw new Error("没有传入的空画布数据");
      if (state.templates.length > 9) {
        Message.info("画板数量不可超过10页");
      }
      const emptyTemplates = Array.isArray(emptyTemplate)
        ? emptyTemplate
        : [emptyTemplate];
      emptyTemplates.forEach((item) => {
        const addIndex = state.templateIndex + 1;
        state.templates.splice(addIndex, 0, {
          handlelist: [item],
          handlelistRedo: [],
        });
        state.templateIndex = addIndex;
      });
    },

    //设置当前画板的指针
    setTemplateIndex(state, index) {
      state.templateIndex = index;
    },

    //通过拖拽重新设置模板数据
    setTemplates(state, newList) {
      state.templates = newList;
    },

    //导入成品模板
    importTemp(state, template) {
      if (!template) throw new Error("没有传入的成品数据");
      const templates = Array.isArray(template) ? template : [template];
      state.templates = [];
      state.templateIndex = 0;
      templates.forEach((item) => {
        const addIndex = state.templateIndex + 1;
        state.templates.splice(addIndex, 0, {
          handlelist: [item],
          handlelistRedo: [],
        });
        state.templateIndex = state.templates.length - 1;
      });
    },

    //单选事件
    selectOne(state, payload) {
      state.mSelectMode = "selectOne";
      state.mSelectOneType = payload[0].type;
      state.mSelectId = payload[0].id;
      state.mSelectIds = payload.map((item) => item.id);
      state.mSelectObject = payload[0];
    },
    //多选事件
    selectMultiple(state, payload) {
      state.mSelectMode = "selectMultiple";
      state.mSelectId = "";
      state.mSelectIds = payload.map((item) => item.id);
      state.mSelectObject = payload;
    },
    //取消选择事件
    selectCancel(state) {
      state.mSelectMode = "";
      state.mSelectOneType = "";
      state.mSelectId = "";
      state.mSelectIds = [];
      state.mSelectObject = [];
    },
    selectedNode(state, val) {
      state.selectedNode = val;
    },
    loadForm(state, val) {
      state.design = val;
    },
    setIsEdit(state, val) {
      state.isEdit = val;
    },
    HIDE_MENU(state) {
      state.isMenuVisible = false;
    },
    SHOW_MENU(state) {
      state.isMenuVisible = true;
    },
  },
  actions: {
    // 使用防抖包装原函数
    fetchButtonPermission: debounce(async function ({ commit }) {
      try {
        commit("SET_BUTTON_PERMISSION", []);
        const { data: res } = await loginService.getButtonPermission(Vue, {});
        if (res.code == 200) {
          commit("SET_BUTTON_PERMISSION", res.data);
        } else {
          Message.error(res.message);
        }
      } catch (error) {
        console.error("获取按钮状态失败:", error);
        Message.error("获取按钮状态失败");
      }
    }, 500), // 这里设置防抖时间为 500 毫秒，可根据需求调整
  },
});
